import http from "./Http";

/**
 * Obtiene el listado de unidades anuales
 *
 * @param {Object} options
 * @param {string|null} options.idInstitucionEdu - ID o código modular de la institución
 * @param {number} options.skip - Offset de paginación (default 0)
 * @param {number} options.limit - Cantidad de registros (default 20)
 *
 * @returns {Promise<{ total: number, items: Array }>}
 */
const obtenerUnidades = async ({
  idInstitucionEdu = null,
  skip = 0,
  limit = 20
} = {}) => {
  const params = {
    skip,
    limit
  };

  // Solo se envía si existe (Admin puede omitirlo)
  if (idInstitucionEdu) {
    params.id_institucion_edu = idInstitucionEdu;
  }

  const res = await http.get("/unidades/", { params });

  const items = res.data?.items ?? [];
  const total = res.data?.total_count ?? 0;

  return {
    total,
    items: items.map(item => ({
      id: item.id,
      nroUnidad: item.nro_unidad,
      nombreUnidad: item.nombre_unidad,
      situacionSignificativa: item.situacion_significativa,
      director: item.director,
      institucion: item.institucion,
      codigoModular: item.codigo_modular,
      fechaCreacion: item.fecha_creacion
    }))
  };
};

/**
 * Guarda unidades anuales
 *
 * @param {Object} payload
 * @param {Array} payload.unidades
 */
const guardarUnidades = async ({ unidades }) => {
  if (!Array.isArray(unidades)) {
    throw new Error("El parámetro 'unidades' debe ser un array");
  }

  const payload = {
    unidades: unidades.map(u => ({
      nro_unidad: u.nroUnidad,
      nombre_unidad: u.nombre,
      situacion_significativa: u.prioridad
    }))
  };

  const res = await http.post("/unidades/guardar", payload);
  return res.data;
};

const UnidadService = {
  obtenerUnidades,
  guardarUnidades,
};

export default UnidadService;
